<template>
  <div class="modal-wrapper">
    <div v-if="student" class="modal-dialog" role="document">
      <div class="modal-content">
        <div class="modal-header">
          <button class="close" @click="$emit('close')" aria-label="Close">
            <span aria-hidden="true">&times;</span>
          </button>
          <h4 ref="modal-title" class="modal-title">
            {{ steps[selectedStep].title }}
          </h4>
        </div>

        <data-confirmation
          v-if="selectedStep === 'dataConfirmation'"
          :current-student-email="student.email"
          :cpf="student.cpf"
          @showEmailDelivered="showEmailDelivered"
          @updateStudentEmail="updateStudentEmail"
        />
        <email-delivered
          v-if="selectedStep === 'emailDelivered'"
          :reset-url="resetUrl"
          :email="student.email"
          @close="$emit('close')"
        />
      </div>
    </div>
    <loading v-else class="cards__loading" full-screen="false" size="small" />
  </div>
</template>

<script>
import { mapState } from 'vuex';
import Loading from 'components/Loading';
import DataConfirmation from './DataConfirmation';
import EmailDelivered from './EmailDelivered';

export default {
  data() {
    return {
      selectedStep: 'dataConfirmation',
      resetUrl: '',
      steps: {
        dataConfirmation: {
          title: 'Redefinir senha - Revisão de dados',
        },
        emailDelivered: {
          title: 'Instruções enviadas!',
        },
      },
    };
  },
  components: {
    DataConfirmation,
    EmailDelivered,
    Loading,
  },
  computed: {
    ...mapState(['student']),
  },
  methods: {
    showEmailDelivered(resetUrl) {
      this.selectedStep = 'emailDelivered';
      this.resetUrl = resetUrl;
    },
    updateStudentEmail(newEmail) {
      this.student.email = newEmail;
    },
  },
};
</script>
